import {
  validatePresence,
  validateFormat,
} from 'ember-changeset-validations/validators';

export default {
  name: [validatePresence(true)],
  provider: [validatePresence(true)],
  url: [
    validatePresence(true),
    validateFormat({ type: 'url', allowBlank: false }),
  ],
};
